import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { webSiteschemaService } from 'src/app/modules/shared/_services/website-schema.service';

@Injectable({
    providedIn: 'root',
})
export class HomePageMetaService {
    private renderer2: Renderer2;

    constructor(
        private title: Title,
        private sharedService: SharedService, private webSiteschema: webSiteschemaService,
        private rendererFactory: RendererFactory2,
        @Inject(DOCUMENT) private document: Document,
        private meta: Meta,
    ) {
        this.renderer2 = this.rendererFactory.createRenderer(null, null);
    }

    setMetas(): void {
        const title = "Find Latest Indian Government Tenders, Private Tenders, E-Tenders Online - TenderShark";
        this.title.setTitle(title);
        this.meta.addTag({ name: 'robots', content: 'index,follow' });

        if (this.sharedService.isServer) {
            const link = this.renderer2.createElement('link');
            link.rel = 'canonical';
            link.href = environment.TENDER.BASE_URL;
            this.renderer2.appendChild(this.document.head, link);

            const description = "Find public & government tenders online at TenderShark. Explore all E-Tenders for any State or Authorities like PWD, NHAI, MC, PHED, RDD, RDPRD Tenders & more.";
            const imageUrl = "https://d1tiqtcifmy0l7.cloudfront.net/prod/images/logo/Tender_Shark_logo.webp";
            const keywordContent = "Online Tenders, Free government Tenders, government tenders, e Tenders India, Construction Tenders,e tendering, eprocurement, ireps tender, cpwd tender, mp tenders, jktenders, wbtenders, Indian Tender notifications, Tender India, best tender sites, get tenders online, Indian Tenders portal, e tender notice,eproc raj";

            this.meta.addTag({ name: 'keywords', content: keywordContent });
            this.meta.addTag({ name: 'description', content: description });
            this.meta.addTag({ name: 'og:title', content: title });
            this.meta.addTag({ name: 'og:description', content: description });
            this.meta.addTag({ name: 'og:site_name', content: 'TenderShark' });
            this.meta.addTag({ name: 'og:type', content: 'website' });
            this.meta.addTag({ name: 'og:url', content: environment.TENDER.BASE_URL });
            this.meta.addTag({ name: 'og:image', content: imageUrl });

            this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
            this.meta.updateTag({ name: 'twitter:site', content: '@tender_shark' });
            this.meta.updateTag({ name: 'twitter:title', content: title });
            this.meta.updateTag({ name: 'twitter:description', content: description });
            this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

            const scriptTag = this.renderer2.createElement('script');
            scriptTag.type = 'application/ld+json';
            scriptTag.text = this.getArticlesSchema({
                metaTitle: title,
                url: imageUrl,
                metaDes: description,
            });
            this.renderer2.appendChild(this.document.head, scriptTag);
            this.webSiteschema.setWebSiteSchema();
        }
    }

    getArticlesSchema(schema: any): string {
        const schemaObj = {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            image: schema.url,
            url: environment.TENDER.BASE_URL,
            logo: schema.url,
            name: 'TenderShark',
            description: schema.metaDes,
            contactPoint: [
                {
                    '@type': 'ContactPoint',
                    contactType: 'customer service',
                    email: 'care@tendershark.com',
                },
            ],
            sameAs: [
                'https://www.facebook.com/people/TenderShark/61562274689255/',
                'https://www.instagram.com/tender__shark/',
                'https://www.linkedin.com/company/tendershark/',
                'https://x.com/tender_shark',
            ],
        };
        return JSON.stringify(schemaObj);
    }

}